var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtsy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4112 7.45402V2.27283H3.19922V4.26225L5.20394 4.59668C5.63657 4.66861 5.97821 5.07154 5.97841 5.51011L6.09589 18.6513C6.09589 18.9082 5.9458 19.4618 5.32143 19.5656L3.3167 19.8991L3.19922 21.7272H19.8744L20.8008 16.5069H19.4112C18.3801 17.6187 17.5561 18.8743 15.8408 18.8744H10.6104C10.3647 18.8744 10.1291 18.7768 9.95534 18.6031C9.78161 18.4293 9.684 18.1937 9.684 17.948L9.76331 13.2224H12.48C12.9085 13.2222 13.3238 13.3705 13.6552 13.6422C13.9866 13.9138 14.2136 14.2918 14.2976 14.712L14.3832 15.2424H16.1688V8.29441H14.3832L14.2976 9.08097C14.2254 9.51359 14.0021 9.90658 13.6674 10.19C13.3328 10.4735 12.9084 10.629 12.4698 10.629H9.80314L9.684 5.12562H15.6491C17.167 5.12585 17.5247 6.32945 18.0216 7.45402H19.4112Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtsy);
export default __webpack_public_path__ + "static/media/etsy.b70ea26faf3ce6c33cde2edf2ebb8887.svg";
export { ForwardRef as ReactComponent };